import { render, staticRenderFns } from "./FormCategory.vue?vue&type=template&id=5b463fa0&scoped=true"
import script from "./FormCategory.vue?vue&type=script&lang=js"
export * from "./FormCategory.vue?vue&type=script&lang=js"
import style0 from "./FormCategory.vue?vue&type=style&index=0&id=5b463fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b463fa0",
  null
  
)

export default component.exports